import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRespondent } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import InterestBar from './InterestBar/InterestBar'
import { useScrollToTop } from 'hooks'
import InterestQuestion from './InterestQuestion/InterestQuestion'
import InterestResults from 'components/interest/InterestResults/InterestResults'
import InterestWelcome from 'components/interest/InterestWelcome/InterestWelcome'
import styles from './InterestQuestionPage.module.scss'
import { toQuiz } from 'ducks/router'
import { t } from 'ttag'

type Respondent = {
  id?: string
  interest?: any
  status?: string
  name?: string
}

const InterestQuestionPage = () => {
  const {
    id: uuid,
    interest,
    status,
    name,
  }: Respondent = useSelector(getRespondent)
  const dispatch = useDispatch()
  const {
    state: { ref, scrollPosition },
    handlers: { handleScroll, handleScrollToTop },
  } = useScrollToTop()

  if (interest.status === 'created') {
    return <InterestWelcome />
  }

  if (interest.status === 'completed') {
    return (
      <WaveContainer containerRef={ref} handleScroll={handleScroll} rollUp>
        <InterestResults
          scrollPosition={scrollPosition}
          handleScrollToTop={handleScrollToTop}
        />
      </WaveContainer>
    )
  }

  if (!status && !name) {
    return (
      <WaveContainer rollUp>
        <div className={styles.noUserContainer}>
          <div className={styles.noUserMessage}>
            {t`Current respondent does not exist`}
          </div>
        </div>
      </WaveContainer>
    )
  }

  return (
    <WaveContainer
      finishButtonLabel={t`Exit`}
      handleExit={() => dispatch(toQuiz({ uuid }))}
      showFinishButton
      rollUp
    >
      <InterestQuestion />
      <InterestBar />
    </WaveContainer>
  )
}

export default InterestQuestionPage
